<template>
  <div class="form-group">
    <div class="d-flex flex-column">

      <div v-if="horizontal">
        <div class="row mb-4">
          <div class="col-3">
            <p class="text-nowrap">ที่อยู่ผู้รับ</p>
          </div>
          <div class="col-9">
            <TextArea wrapper_class="mb-1"
                      :id="id + 'sa-address'"
                      rows="3"
                      rules="required"
                      @input="emitChanges"
                      v-model="addr" />

            <Button v-if="addr && addr.length"
                    type="button"
                    variant="primary"
                    @click="parseAddress()"
                    :loading="parseLoading"
                    :disabled="parseLoading"
                    size="sm">

              {{ parseLoading ? "กำลังแยกที่อยู่..." : "จำแนกที่อยู่" }}
            </Button>
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <p class="text-nowrap">ตำบล/แขวง</p>
          </div>
          <div class="col-9">
            <TextBox type="text"
                     :id="id + 'sa-amphoe'"
                     rules="required"
                     @change="emitChanges"
                     v-model="subDist" />
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <p class="text-nowrap">อำเภอ/เขต</p>
          </div>
          <div class="col-9">
            <TextBox type="text"
                     :id="id + 'sa-district'"
                     rules="required"
                     @change="emitChanges"
                     v-model="dist" />
          </div>
        </div>

        <div class="row">
          <div class="col-3">
            <p class="text-nowrap">จังหวัด</p>
          </div>
          <div class="col-9">
            <TextBox type="text"
                     :id="id + 'sa-province'"
                     rules="required"
                     @change="emitChanges"
                     v-model="prov" />
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <p class="text-nowrap">รหัสปณ.</p>
          </div>
          <div class="col-9">
            <NumberField :id="id + 'sa-zipcode'"
                         rules="required"
                         @change="emitChanges"
                         v-model="zip" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NumberField from "@/components/core/NumberField";
import TextBox from "@/components/core/TextBox";
import Button from "@/components/core/Button";
import TextArea from "@/components/core/TextArea";
import { http } from "@/helpers/http";
import _ from "lodash";

export default {
  name: "SmartAddress",
  components: { NumberField, Button, TextBox, TextArea },
  props: {
    horizontal: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    id: {
      type: String,
      default: "sa-" + Math.random(),
    },
    value: {
      type: null,
    },
    rules: {
      type: String,
      default: "",
    }
  },

  data() {
    return {
      parseTimer: null,
      parseLoading: false,

      addr: null,
      dist: null,
      subDist: null,
      prov: null,
      zip: null,
      phoneNo: null,
      name: null
    };
  },

  created() {
    if (this.value) {
      this.addr = this.value.addr || null;
      this.dist = this.value.dist || null;
      this.subDist = this.value.subDist || null;
      this.prov = this.value.prov || null;
      this.zip = this.value.zip || null;
    }
  },

  mounted() {
    this.applyThaiAddParse();
  },

  methods: {
    async parseAddress() {
      if (!(this.addr && this.addr.length)) return;

      try {
        this.parseLoading = true;
        const { data } = await http.get(`https://a3jczw1yof.execute-api.ap-southeast-1.amazonaws.com/dev/v1/parse-address?text=${encodeURIComponent(this.addr.replace("\n", "~"))}`)
        if (data) {
          if (data.nameAddress) {
            if (data.nameAddress.includes("~")) {
              const [name, address] = data.nameAddress.split("~")
              this.addr = address.replaceAll("~", "").replaceAll("\n", "");
              this.name = name.replaceAll("~", "").replaceAll("\n", "");
            } else this.addr = data.nameAddress.replaceAll("~", "").replaceAll("\n", "");
          }
          if (data.subdistrictName) this.subDist = data.subdistrictName;
          if (data.districtName) this.dist = data.districtName;
          if (data.provinceName) this.prov = data.provinceName;
          if (data.zipcode) this.zip = Number(data.zipcode);
          if (data.phone) this.phoneNo = data.phone;
          this.emitChanges();
        }
        this.parseLoading = false;
      } catch (e) {
        console.log(e)
      }
    },

    applyThaiAddParse() {
      setTimeout(() => {
        $.Thailand({
          database: "https://proship-dev.s3.ap-southeast-1.amazonaws.com/proship_files/db.json",
          $district: $(`#${this.id}sa-district`),
          $amphoe: $(`#${this.id}sa-amphoe`),
          $province: $(`#${this.id}sa-province`),
          $zipcode: $(`#${this.id}sa-zipcode`),
          onDataFill: (data) => {
            if (data.amphoe) this.dist = data.amphoe;
            if (data.district) this.subDist = data.district;
            if (data.province) this.prov = data.province;
            if (data.zipcode) this.zip = data.zipcode;
            this.emitChanges();
          },
        });
      }, 500);
    },

    emitChanges() {
      this.$emit("change", {
        addr: this.addr,
        dist: this.dist,
        subDist: this.subDist,
        prov: this.prov,
        zip: this.zip,
        phoneNo: this.phoneNo,
        name: this.name
      });
    }
  },

  watch: {
    value(newVal, oldVal) {
      if (newVal) {
        if (newVal.addr !== oldVal.addr) this.addr = newVal.addr;
        if (newVal.dist !== oldVal.dist) this.dist = newVal.dist;
        if (newVal.subDist !== oldVal.subDist) this.subDist = newVal.subDist;
        if (newVal.prov !== oldVal.prov) this.prov = newVal.prov;
        if (newVal.zip !== oldVal.zip) this.zip = newVal.zip;
        if (newVal.phoneNo !== oldVal.phoneNo) this.phoneNo = newVal.phoneNo;
        if (newVal.name !== oldVal.name) this.name = newVal.name;
      }

    }
  },
};
</script>

<style scoped
       lang="scss">
      .clipboardArea {
        background-color: whitesmoke;
        padding: 1rem;
        color: map-get($text-colors, 5);
        text-align: center;
        cursor: pointer;
      }

      .parsingStatus {
        min-width: 55px;
      }

      .manualInput {
        input {
          padding: 3px 6px;
          font-size: 12px;
          margin: 0.1rem;
        }
      }
    </style>